import { HttpClient, SwaggerApi } from '@/Swagger';

import axiosInstance from './axios';

class AIMSApiWrapper extends SwaggerApi<void> {
  constructor(http: HttpClient<void>) {
    super(http);
    http.instance = axiosInstance;

    // const originalApi = { ...this.shops };
  }
}

export const aimsApi = new AIMSApiWrapper(new HttpClient());
